import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { USER_DAC7_ACTION } from 'store/actions/user-dac7.actions';
import { useAppSelector } from 'store/hooks';
import { CountryPropertyType, IBusinessEntityData, IPrivatePersonData, UserAccountType } from 'types/user.types';
import { getCountries } from 'utils/countries';
import { camelToKebabCase } from 'utils/format-text';

import { useLanguage } from '../../hooks/useLanguage';

export const Dac7FormConfirmationDialog = () => {
  const { accountType, data, canSubmit, isOpen } = useAppSelector(({ userData }) => {
    const { isOpen } = userData.userDac7FormConfirmation;
    const { accountType, data, isValid, isTouched } = userData.userDac7Form;

    return {
      accountType,
      data: data[accountType as UserAccountType] as IPrivatePersonData | IBusinessEntityData,
      isOpen,
      canSubmit: isValid[accountType] && isTouched[accountType],
    };
  });

  const { t } = useTranslation();
  const { language } = useLanguage();

  const countries = useMemo(() => getCountries(language), [language]);

  const getFieldValue = (fieldName, fieldValue) => {
    if ([CountryPropertyType.BUSINESS, CountryPropertyType.PRIVATE_PERSON].includes(fieldName)) {
      const country = countries.find(({ code }) => code === fieldValue);

      return country?.name;
    }

    return fieldValue || '-';
  };

  return (
    <Dialog className="dac7-form-confirmation" open={canSubmit && isOpen}>
      <DialogTitle>{t('pages.DAC7.form.confirmation.title')}</DialogTitle>
      <DialogContent className="dac7-form-confirmation__content" dividers>
        <p>{t('pages.DAC7.form.confirmation.check-request')}</p>
        {Object.entries(data).map(([fieldName, fieldValue]) =>
          fieldName.includes('_') ? null : (
            <div className="dac7-form-confirmation__content-group" key={fieldName}>
              <span className="dac7-form-confirmation__content-group-label">
                {t(`pages.DAC7.form.${camelToKebabCase(accountType)}.${camelToKebabCase(fieldName)}`)}
              </span>
              <span className="dac7-form-confirmation__content-group-text">{getFieldValue(fieldName, fieldValue)}</span>
            </div>
          ),
        )}
      </DialogContent>
      <DialogActions className="dac7-form-confirmation__action">
        <div className="dac7-form-confirmation__action-terms">{t('pages.DAC7.form.confirmation.agree-with-terms')}</div>
        <div className="dac7-form-confirmation__action-buttons">
          <Button variant="outlined" onClick={USER_DAC7_ACTION.cancelConfirmation}>
            {t('pages.DAC7.form.cancel')}
          </Button>
          <Button className="profile-save-btn" variant="contained" color="primary" onClick={USER_DAC7_ACTION.submitConfirmation}>
            {t('pages.DAC7.form.send')}
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};
